import { INSTANCE_SETUP_READ, INSTANCE_SETUP_UPDATE, INSTANCE_SETUP_UPDATE_STATUS, INSTANCE_SETUP_NAVIGATE } from 'client/redux/instance/constants';
import { reduceByTypes } from 'client/redux/apiHelpers';
import _ from 'lodash'; // Import lodash for deep merging

const defaultState = {
  isReading: false,
  isUpdating: false,
  error: null,
  wizard: null,
  instance: null,
  connector: null,
  endpointsByType: null,
  optionalEndpoints: [],
};

export default function setupReducer (state = defaultState, action) {
  state = reduceByTypes(INSTANCE_SETUP_READ, state, action, {
    requestProp: 'isReading',
    successSpread: true,
    successPickProps: [
      'wizard',
      'instance',
      'endpointsByType',
      'connector',
      'subscription',
      'optionalEndpoints',
    ],
  });

  // Handle general instance updates during setup (e.g., saving settings)
  state = reduceByTypes(INSTANCE_SETUP_UPDATE, state, action, {
    requestProp: 'isUpdating',
    // Custom successProp to handle nested settings in API response
    successProp: (currentState, actionPayload) => {
      // Pick the relevant top-level properties from the payload first
      const baseUpdate = _.pick(actionPayload, ['wizard', 'endpointsByType', 'connector']);
      
      // Get the instance object from the payload
      const instanceFromPayload = _.get(actionPayload, 'instance');
      if (!instanceFromPayload) {
        // If no instance in payload, just return the base update
        return baseUpdate;
      }

      // Directly use the settings from the main instance payload
      const updatedInstanceSettings = _.get(actionPayload, 'instance.settings');
      
      // Create a new instance object using the settings from the payload
      const updatedInstance = {
        ...instanceFromPayload,
        // Directly assign the settings object received in the payload
        settings: updatedInstanceSettings || instanceFromPayload.settings, // Use payload settings, fallback to existing if somehow missing
      };

      // Return the base update merged with the corrected instance
      return {
        ...baseUpdate,
        instance: updatedInstance,
      };
    },
    // Remove successSpread and successPickProps as we use custom successProp
    // successSpread: true,
    // successPickProps: ['wizard', 'instance', 'endpointsByType', 'connector']
  });

  // Handle updating the instance status during setup
  state = reduceByTypes(INSTANCE_SETUP_UPDATE_STATUS, state, action, {
    requestProp: 'isUpdating',
    successSpread: true,
    successPickProps: ['instance'],
  });

  // Handler specifically for wizard navigation updates
  state = reduceByTypes(INSTANCE_SETUP_NAVIGATE, state, action, {
    requestProp: 'isUpdating', // Reuse isUpdating or change if needed
    successSpread: true, // Assume payload structure is flat enough
    // Only pick wizard and potentially the instance if backend updates it during nav
    successPickProps: ['wizard', 'instance'], 
  });

  return state;
}
